import { styled, Box, Button } from '@mui/material'
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress'
import theme from 'lib/theme'

export const LabelsWrapper = styled(Box, {
  shouldForwardProp: (props) => props !== 'backgroundColor',
})<{ backgroundColor: string }>(({ backgroundColor }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor,
  minHeight: '20px',
  minWidth: '64px',
  borderRadius: '15px',
  marginBottom: theme.spacing(1),
  padding: '4px 8px',
}))

export const LabelsCount = styled(Box, {
  shouldForwardProp: (props) => props !== 'backgroundColor',
})<{ backgroundColor: string }>(({ backgroundColor }) => ({
  marginLeft: theme.spacing(0.5),
  padding: '3px',
  height: '24px',
  width: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '50%',
  backgroundColor,
}))

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.neutral.grey9,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.brand.blue,
  },
}))

export const NeutralBtn = styled(Button)(({ theme }) => ({
  color: theme.palette.commonColors.black,
  backgroundColor: theme.palette.neutral.grey9,
  '&:hover': {
    backgroundColor: theme.palette.neutral.grey7,
  },
  padding: '2px 46px',
}))
